import { CreateAPIClientDTO, type CreatedAPIClientDTO } from "@pentacode/core";
import { css, html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { app } from "../../init";
import { alert } from "../alert-dialog";
import { Dialog } from "../dialog";

@customElement("ptc-new-api-client-dialog")
export class NewAPIClientDialog extends Dialog<void, CreatedAPIClientDTO> {
    preventDismiss = true;

    @query("form")
    private _form: HTMLFormElement;

    private async _submit(e: Event) {
        e.preventDefault();

        const data = new FormData(this._form);

        this.loading = true;
        try {
            const created = await app.api.createAPIClient(
                new CreateAPIClientDTO({
                    name: data.get("name") as string,
                    email: data.get("email") as string,
                    website: data.get("website") as string,
                })
            );

            this._form.reset();
            this.loading = false;
            this.done(created);
        } catch (e) {
            this.loading = false;
            await alert(e.message, { type: "warning" });
        }
    }

    async show() {
        const promise = super.show();
        await this.updateComplete;
        return promise;
    }

    static styles = [
        ...Dialog.styles,
        css`
            .inner {
                --dialog-max-width: 500px;
                --dialog-width: 500px;
            }
        `,
    ];

    renderContent() {
        return html`
            <form class="vertical layout" @submit=${this._submit}>
                <div class="margined text-centering big">Neuer API-Client</div>

                <div class="padded">
                    <div class="field">
                        <label>Name</label>
                        <input type="text" name="name" placeholder="Name des Partners" required />
                    </div>

                    <div class="field">
                        <label>E-Mail</label>
                        <input type="email" name="email" placeholder="kontakt@partner.de" required />
                    </div>

                    <div class="field">
                        <label>Website</label>
                        <input type="url" name="website" placeholder="https://partner.de" required />
                    </div>
                </div>

                <div class="padded horizontal spacing evenly stretching layout">
                    <button class="primary">API-Client erstellen</button>
                    <button class="transparent" type="button" @click=${() => this.done()}>Abbrechen</button>
                </div>
            </form>
        `;
    }
}
